import HeartBrokenIcon from '@mui/icons-material/HeartBroken';
import RemoveRoadIcon from '@mui/icons-material/RemoveRoad';
import { Avatar, Tooltip, Typography, alpha, darken } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import palette from '../layout/ColorPalette';
import { INVALID_SCORE } from '../layout/content/Metrics/SafetyWellness/scoreConstants';
import { getScoreColor } from '../utils/getScoreColor';

export interface ScoreAvatarProps {
    score?: number;
    size?: number;
    fontSize?: number;
    inactive?: boolean;
    unknown?: boolean;
}

export const ScoreAvatar: React.FC<ScoreAvatarProps> = (props: ScoreAvatarProps) => {
    const { t } = useTranslation();
    let color = palette.gray[600];
    if (props.score !== undefined && props.score !== INVALID_SCORE) {
        color = getScoreColor(props.score);
    }

    let scoreStr = 'NA';
    let iconElement = null;

    if (props.score === INVALID_SCORE) {
        if (props.inactive || props.unknown) {
            scoreStr = props.inactive ? 'inactive' : 'unknown';
            const iconStyle = { fontSize: props.fontSize ? props.fontSize + 4 : 20 };
            const iconComponent = props.inactive ? (
                <RemoveRoadIcon sx={iconStyle} />
            ) : (
                <HeartBrokenIcon sx={iconStyle} />
            );
            iconElement = <Tooltip title={t(`content.safety.score_${scoreStr}`)}>{iconComponent}</Tooltip>;
        }
    } else if (props.score !== undefined) {
        scoreStr = Math.round(props.score).toString();
    }

    const scoreElement = (
        <Typography sx={{ fontSize: props.fontSize || 14, fontWeight: 'bold' }}>{scoreStr}</Typography>
    );

    const finalScoreElement = iconElement || scoreElement;

    return (
        <Avatar
            variant="rounded"
            data-testid="score-avatar"
            data-score={scoreStr}
            sx={{
                width: props.size || 28,
                height: props.size || 28,
                color: darken(color, 0.1),
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: darken(color, 0.1),
                backgroundColor: alpha(color, 0.1),
                alignItems: 'center',
            }}
        >
            {finalScoreElement}
        </Avatar>
    );
};
